export default function ArrowIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.0002 13.2807L5.65355 8.93404C5.14022 8.4207 5.14022 7.5807 5.65355 7.06737L10.0002 2.7207"
            strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
